import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * QA (POM-6184): the single sentence read "part of this quantity" even when the whole order had
 * moved, where nothing was left behind to be a part of. Which one applies is decided by the
 * caller, which is the only place that knows whether the order, the line item or a slice of its
 * quantity moved.
 */
export const FILL_LATER_PENDING_TITLE = {
  ORDER:
    'Fill Later: the whole order was moved to Fill Later and is scheduled to be ordered on a later date.',
  ITEM: 'Fill Later: the whole quantity of this item was moved to Fill Later and is scheduled to be ordered on a later date.',
  PARTIAL:
    'Fill Later: part of this quantity was split off and is scheduled to be ordered on a later date.',
};

export const FILL_LATER_PENDING_SCOPES = Object.keys(FILL_LATER_PENDING_TITLE);

/**
 * POM-6148 AC7 / POM-6198: marks a line item that has at least one pending Fill Later row
 * (`isMarkedForFillLater`). Same shape as the Item ID copy control beside it: an icon inside an
 * IconButton so the tooltip opens on hover, focus and tap. Sits beside the dispensing quantity,
 * which is the number the split reduced.
 */
const FillLaterPendingIcon = ({ lineItemId, scope, sx }) => (
  <Tooltip title={FILL_LATER_PENDING_TITLE[scope]} arrow placement='top'>
    <IconButton
      size='small'
      aria-label={`Fill Later pending ${lineItemId}`}
      sx={{ ml: 0.5, color: 'warning.warningColour', ...sx }}
    >
      <EventRepeatIcon fontSize='inherit' />
    </IconButton>
  </Tooltip>
);

FillLaterPendingIcon.propTypes = {
  lineItemId: PropTypes.string.isRequired,
  scope: PropTypes.oneOf(FILL_LATER_PENDING_SCOPES),
  sx: PropTypes.shape({}),
};

FillLaterPendingIcon.defaultProps = {
  scope: 'PARTIAL',
  sx: undefined,
};

export default FillLaterPendingIcon;
